import View from '../View';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Div Block',
  showEmpty: true,
  style: {
    base: {
      main: {
        noPseudo: {
          marginLeft: px(12),
          marginRight: px(12),
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
        },
      },
    },
  },
  render: View,
  fields: {children: TListOfElement},
});

export default config;
